import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import * as queryString from 'query-string'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Text from '../../commons/Text/Text'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import Button from '../../commons/Button/Button'
import FlameSantander from '../../commons/Icons/FlameSantander'
import Flex from '../../commons/Flex/Flex'

const ConfirmRegisterEmailContainer = ({ location }) => {
  const { email } = queryString.parse(location.search)

  const dispatch = useDispatch()
  const handleResent = () => {
    dispatch(reducks.resources.users.actions.confirmUserEmailResent())
  }

  useEffect(() => {
    const requirements = ['email', 'password']
    dispatch(
      reducks.resources.users.actions.registerUserRequirements(
        requirements,
        routes.registerCNPJ.path
      )
    )
  }, [])

  return (
    <ExternalLayout>
      <Flex column justifyContent="flex-start">
        <FlameSantander />
        <Text
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Autenticação.
        </Text>
        <Text
          color="gray"
          variation="dark"
          size="md"
          margin="10px 0px"
          fontWeight="400"
        >
          Um e-mail com um link de confirmação foi enviado para {email}.
        </Text>
        <Text color="gray" variation="dark" size="md" fontWeight="400">
          Não recebeu o e-mail de confirmação?
        </Text>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="flex-start"
        margin="32px 0px 0px 0px"
      >
        <Button
          type="secondary"
          buttonType="button"
          width="163px"
          onClick={() => handleResent()}
        >
          <Text font="custom" color="white" size="xs" value="Reenviar" bold />
        </Button>
      </Flex>
      <Text
        font="custom"
        fontWeight="400"
        color="gray"
        size="xxs"
        margin="37px 0px"
        lineHeight="18px"
      >
        Caso não tenha recebido o e-mail, certifique-se de que o e-mail
        informado está correto e verifique a sua caixa de spam.
      </Text>
    </ExternalLayout>
  )
}

ConfirmRegisterEmailContainer.defaultProps = {
  location: {}
}

ConfirmRegisterEmailContainer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  })
}

export default ConfirmRegisterEmailContainer
